import { derived, writable } from 'svelte/store'
import {
    emailFieldValidator,
    phoneNumberFieldValidator,
    requiredFieldValidator
} from "../common/validation/validators";
import { every } from 'lodash';

let storedUser = !sessionStorage.getItem("registeredUser") ?
    {
        name: "",
        initial: "",
        lastName: "",
        email: "",
        phoneNumber: ""
    } :
    JSON.parse(sessionStorage.getItem("registeredUser"))

export const registeredUser = writable(storedUser)

registeredUser.subscribe(value => {
    sessionStorage.setItem("registeredUser", JSON.stringify(value))
})


export const userValidation = derived(registeredUser,
    $registeredUser => ({
        nameResult: requiredFieldValidator(true, $registeredUser.name),
        lastNameResult: requiredFieldValidator(true, $registeredUser.lastName),
        emailResult: emailFieldValidator(true, $registeredUser.email),
        phoneNumberResult: phoneNumberFieldValidator(true, $registeredUser.phoneNumber)
    }))

export const registerPageState = derived(userValidation, (validationResults) =>
    every(validationResults, 'valid'));

